import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { downgradeComponent } from '@angular/upgrade/static';
import App from '@app/app';
import { LtTranslatePipe } from '@app/pipes/lt-translate.pipe';
import { LtIconComponent } from '@app/components/core/lt-icon/lt-icon.component';

@Component({
  selector: 'lt-page-header',
  standalone: true,
  imports: [NgClass, LtTranslatePipe, LtIconComponent],
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageHeaderComponent {
  headerKey = input.required<string>();
  descKey = input.required<string>();
  subtitleClass = input<string>('');
  backLabel = input<string>('');
  back = output<void>();

  onBackClicked(): void {
    this.back.emit();
  }
}
App.directive(
  'ltPageHeader',
  downgradeComponent({
    component: PageHeaderComponent
  })
);
